import { X } from "lucide-react";
import {
  formatDisplay,
  formatFullDate,
  formatTime,
} from "../../../../lib/utils";

const VulnerabilityDetails = ({ isOpen, setIsOpen, details }) => {
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="relative">
      {isOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50"
          onClick={handleClose} // Close modal when clicking on overlay
        >
          <div
            className="bg-white rounded-lg shadow-lg p-6 overflow-y-auto max-h-[600px]  xl:w-[40%] lg:w-[45%] md:w-[60%] w-[90%]"
            onClick={(e) => e.stopPropagation()} // Prevent close when clicking inside the modal
          >
            <div className="flex justify-between mb-3 items-center">
              <h2 className="text-xl capitalize font-bold text-darkBlue">
                Vulnerability Details
              </h2>

              <X className="cursor-pointer " onClick={handleClose} size={20} />
            </div>
            <hr />
            <div className="flex flex-col gap-2 my-4">
              <p>
                <span className="font-medium mr-1">Name:</span>
                {details.vulnerability_name}
              </p>
              {(details?.scan?.target?.name || details?.target_name) && (
                <p>
                  <span className="font-medium mr-1">Asset:</span>
                  {details?.scan?.target?.name || details?.target_name}
                </p>
              )}
              <p>
                <span className="font-medium mr-1">Severity:</span>
                {details.threat_level}
              </p>
              <p>
                <span className="font-medium mr-1">Host:</span>
                {details?.processed_host || details?.processed_hosts || "--"}
              </p>
              <p>
                <span className="font-medium mr-1 ">Status:</span>
                <span className="capitalize">
                  {details.status === "pending"
                    ? "Unresolved"
                    : details.status ?? "--"}
                </span>
              </p>
              <p>
                <span className="font-medium mr-1">CVE ID:</span>
                {details?.cve_id && details?.cve_id !== ""
                  ? formatDisplay(details?.cve_id)
                  : "--"}
              </p>
              <p>
                <span className="font-medium mr-1">Discovered:</span>
                <span>{formatFullDate(details.discovered_at)}</span>
              </p>
              <p>
                <span className="font-medium mr-1">Last Scanned:</span>
                <span>
                  {formatFullDate(
                    details?.scan?.target?.last_scanned ||
                      details?.target_last_scanned_at ||
                      details.created_at
                  )}
                  ,
                </span>{" "}
                <span>
                  {formatTime(
                    details?.scan?.target?.last_scanned ||
                      details?.target_last_scanned_at ||
                      details.created_at
                  )}
                </span>
              </p>
              <p className="whitespace-pre-line break-words">
                <span className="font-medium mr-1">Description:</span>
                {details.description.replace(/\\n/g, "\n")}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VulnerabilityDetails;
